export default "__VITE_ASSET__DaQpazYA__"